import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportSectionHeader = ({ title, icon, count }) => {
  return (
    <div className="flex items-center gap-3 mb-4 pb-2 border-b border-border">
      <div className="flex items-center justify-center w-8 h-8 bg-accent/10 rounded-md flex-shrink-0">
        <Icon name={icon} size={16} color="var(--color-accent)" />
      </div>
      <h2 className="text-base font-semibold text-foreground flex-1">{title}</h2>
      {count !== undefined && (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent text-accent-foreground">
          {count}
        </span>
      )}
    </div>
  );
};

export default ReportSectionHeader;
